import React from 'react';
import classNames from 'classnames';
import { useCloseEventHandler } from './useCloseEventHandler';

interface IProps {
  trigger: any;
  children: React.ReactNode;
  anchorSide?: 'left' | 'right';
  open?: boolean;
  loading?: boolean;
  onClose?: () => void;
}

export default function Popover({
  children,
  trigger,
  anchorSide = 'left',
  open = false,
  loading = false,
  onClose = () => {},
}: IProps) {

  const popoverRef = React.useRef<HTMLInputElement>();
  const [isOpen, toggleIsOpen] = React.useState(open);
  const [alignRight, setAlignRight] = React.useState(anchorSide === 'right');

  React.useEffect(() => {
    toggleIsOpen(open);
  }, [open]);

  const closeHandler = React.useCallback(() => { handleClose(); }, [handleClose]);
  useCloseEventHandler({ isOpen, ref: popoverRef, handler: closeHandler });

  const classes = classNames(
    'popover',
    { 'popover--open': isOpen },
    { 'popover--anchor-right': alignRight },
    { 'popover--loading': loading },
  );

  if (!trigger) return null;

  function handleClick() {
    if (!isOpen) {
      const container = popoverRef.current.lastElementChild.getBoundingClientRect();
      const windowWidth = window?.innerWidth || 10000;
      if (container.right >= windowWidth) {
        setAlignRight(true);
      }
      if (container.left <= 0) {
        setAlignRight(false);
      }
      return toggleIsOpen(true);
    }
    return handleClose();
  }

  function handleClose() {
    toggleIsOpen(false);
    onClose();
  }

  return (
    <div
      className={classes}
      ref={popoverRef}
    >
      {React.cloneElement(
        trigger,
        { onClick: handleClick },
      )}
      <div className="popover__wrapper">
        <div className="popover__content">
          {children}
        </div>
      </div>
    </div>
  );
}
